import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Items from './pages/Items';
import Stores from './pages/Stores';
import StoreInventory from './pages/StoreInventory';
import Purchases from './pages/Purchases';
import Sales from './pages/Sales';
import Waste from './pages/Waste';
import Transfers from './pages/Transfers';
import CountingSessions from './pages/CountingSessions';
import CountEntry from './pages/CountEntry';
import Reconciliations from './pages/Reconciliations';
import ReconciliationDetail from './pages/ReconciliationDetail';
import Users from './pages/Users';
import AuditLog from './pages/AuditLog';
import AdminTools from './pages/AdminTools';
import './theme/tokens.css';
import './components/ui/ui.css';
import './App.css';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (user.role !== 'admin') return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="items" element={<Items />} />
            <Route path="stores" element={<Stores />} />
            <Route path="stores/:storeId/inventory" element={<StoreInventory />} />
            <Route path="purchases" element={<Purchases />} />
            <Route path="sales" element={<Sales />} />
            <Route path="waste" element={<Waste />} />
            <Route path="transfers" element={<Transfers />} />
            <Route path="counting" element={<CountingSessions />} />
            <Route path="counting/:sessionId" element={<CountEntry />} />
            <Route path="reconciliations" element={<Reconciliations />} />
            <Route path="reconciliations/:reconId" element={<ReconciliationDetail />} />
            <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="admin-tools" element={<AdminRoute><AdminTools /></AdminRoute>} />
          </Route>
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
